// Base
import dynamic from 'next/dynamic'

// Components
import { Container, Box, Flex, Text } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'
import TextReviewCard from '@components/v25/es/cards/review/TextReviewCard'
import ExperienceCard from '@components/v25/es/ft1/cards/customer-experience/ExperienceCard'

// Assets
import CardImage1 from '@images/v25/photos/customers-3.png'
import CardImage2 from '@images/v25/photos/customers-2.png'

const experiences = [
  {
    card: {
      img: CardImage1,
      destination: 'Thailandia',
      date: 'Feb 12-24',
      prices: { old: 849, new: 289 }
    },
    review: {
      name: 'Maria P.',
      quote:
        '“Mi marido y yo visitamos Tailandia de casualidad en nuestra luna de miel gracias a Ratepunk”',
      message:
        'Recibimos una alerta de que había pasajes a Tailandia y las fechas coincidían con nuestra luna de miel. Al instante compramos los pasajes. Fue una de las mejores decisiones de nuestras vidas, ¡¡¡gracias!!!',
      memberSince: 2018
    }
  },
  {
    card: {
      img: CardImage2,
      destination: 'Hawái',
      date: 'Oct 1-5',
      prices: { old: 600, new: 230 }
    },
    review: {
      name: 'Paula M.',
      quote: '“¡Por fin visité el destino de mis sueños!”',
      message:
        'Mis amigos y yo conseguimos un vuelo barato a Hawái. Era uno de los lugares de mis sueños que quería visitar. Fuimos a hacer senderismo por las montañas, surf, esnórquel e incluso jugamos al golf jaja. Todo por culpa de Ratepunk, gracias <3',
      memberSince: 2021
    }
  }
]

const CustomerExperiences = () => {
  return (
    <Section>
      <Box>
        <Text
          tagName="h2"
          variant="title-2"
          align="center"
          transform="capitalize"
          spacing={{ sm: 32 }}
        >
          Experiencias de nuestros clientes
        </Text>

        <Container>
          <Flex flexDirection="column" rowGap={{ sm: 24 }} spacing={{ sm: 64 }}>
            {experiences.map((deal, index) => (
              <Flex flexDirection="column" rowGap={{ sm: 24 }} key={index}>
                <ExperienceCard {...deal.card} />
                <TextReviewCard {...deal.review} />
              </Flex>
            ))}
          </Flex>
        </Container>
      </Box>
    </Section>
  )
}

export default CustomerExperiences
